import React, { useState } from 'react';
import { FaUsers, FaChartLine, FaMobile, FaShieldAlt, FaMapMarkerAlt, FaReceipt, FaArrowRight, FaPlay } from 'react-icons/fa';
import igfLogo from './igfff-01.png';
import igfwhite from './IGF 360 SEECTED-02 (1).png';
import './LandingPage.css';

const LANDING_URL = 'https://portal.igf360.com/';

const LandingPage = () => {
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      icon: <FaUsers />,
      title: "Multi-tier Administration",
      description: "SuperAdmin → MMDA → Revenue Officers → Traders hierarchy with role-based access control",
      details: "Comprehensive user management system with granular permissions for different user types"
    },
    {
      icon: <FaChartLine />,
      title: "Real-time Revenue Tracking",
      description: "Live monitoring of collections across all zones with comprehensive analytics",
      details: "Track revenue performance, generate reports, and monitor collection trends in real-time"
    },
    {
      icon: <FaMobile />,
      title: "USSD Integration",
      description: "Mobile-based revenue collection for traders using feature phones",
      details: "Enable revenue collection even in areas with limited smartphone access"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Zone-based Operations",
      description: "Geographical revenue management with zone grouping and assignment",
      details: "Organize operations by geographical zones for efficient management and oversight"
    },
  ];

  const stats = [
    { number: "100+", label: "MMDAs Supported" },
    { number: "1000+", label: "Revenue Officers" },
    { number: "50K+", label: "Registered Traders" },
    { number: "₵10M+", label: "Revenue Collected" }
  ];

  const userRoles = [
    {
      title: "SuperAdmin",
      description: "Complete system oversight and management",
      features: ["Manage all MMDAs", "Zone management", "System configuration", "Audit oversight"]
    },
    {
      title: "MMDA Admin",
      description: "District-level administration and oversight",
      features: ["Manage revenue officers", "District analytics", "Trader oversight", "Local reporting"]
    },
    {
      title: "Field Officer",
      description: "On-ground revenue collection and trader management",
      features: ["Revenue collection", "Trader registration", "Receipt generation", "Mobile operations"]
    }
  ];

  const handleGetStarted = () => {
    window.open(LANDING_URL, '_blank');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(#1976d2 50%, #ffffff 50%)',
      fontFamily: 'Arial, sans-serif'
    }}>
      {/* Header */}
      <header style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        padding: '1rem 0',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <img src={igfLogo} alt="iGF360" style={{ height: '80px' }} />
            <div>
            </div>
          </div>
          <button
            onClick={handleGetStarted}
            style={{
              background: '#1976d2',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '25px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
            }}
          >
            Get Started <FaArrowRight />
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{
        padding: '2rem 1rem',
        textAlign: 'center',
        color: 'white'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            fontWeight: 'bold',
            marginBottom: '1.5rem',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}>
            MMDA Revenue Mobilisation  System
          </h1>
          <p style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
            marginBottom: '2rem',
            opacity: 0.9,
            lineHeight: '1.6',
            maxWidth: '600px',
            margin: '0 auto 2rem auto'
          }}>
            Comprehensive revenue collection and management platform for Ghana's Metropolitan, Municipal 
            and District Assemblies. Streamline operations, enhance transparency, and maximize revenue collection.
          </p>
          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
            maxWidth: '500px',
            margin: '0 auto'
          }}>
            <button
              onClick={handleGetStarted}
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                border: '2px solid white',
                padding: '15px 30px',
                borderRadius: '30px',
                cursor: 'pointer',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'white';
                e.target.style.color = '#1976d2';
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                e.target.style.color = 'white';
              }}
            >
              <FaPlay /> Start Managing Revenue
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        padding: '3rem 2rem',
        margin: '0 2rem',
        borderRadius: '20px',
        marginBottom: '4rem'
      }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '2rem',
            textAlign: 'center'
          }}>
            {stats.map((stat, index) => (
              <div key={index} style={{ color: 'white' }}>
                <h3 style={{
                  fontSize: '2.5rem',
                  fontWeight: 'bold',
                  margin: '0 0 0.5rem 0',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                }}>
                  {stat.number}
                </h3>
                <p style={{ fontSize: '1.1rem', opacity: 0.9, margin: 0 }}>
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{
        background: 'white',
        padding: '2rem 1rem',
        borderRadius: '30px 30px 0 0'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            color: '#1976d2',
            marginBottom: '2rem'
          }}>
            Powerful Features for Modern Revenue Management
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1.5rem'
          }}>
            {features.map((feature, index) => (
              <div
                key={index}
                style={{
                  background: activeFeature === index ? '#1976d2' : '#f8f9fa',
                  color: activeFeature === index ? 'white' : '#1976d2',
                  padding: '2rem',
                  borderRadius: '15px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: activeFeature === index ? '0 10px 30px rgba(25, 118, 210, 0.3)' : '0 5px 15px rgba(0,0,0,0.1)',
                  transform: activeFeature === index ? 'translateY(-5px)' : 'translateY(0)'
                }}
                onMouseEnter={() => setActiveFeature(index)}
                onMouseLeave={() => setActiveFeature(-1)}
              >
                <div style={{
                  fontSize: '2rem',
                  marginBottom: '1rem',
                  opacity: activeFeature === index ? 1 : 0.7
                }}>
                  {feature.icon}
                </div>
                <h3 style={{
                  fontSize: '1.3rem',
                  marginBottom: '1rem',
                  fontWeight: 'bold'
                }}>
                  {feature.title}
                </h3>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  marginBottom: '1rem',
                  opacity: 0.9
                }}>
                  {feature.description}
                </p>
                <p style={{
                  fontSize: '0.9rem',
                  lineHeight: '1.5',
                  opacity: 0.8,
                  fontStyle: 'italic'
                }}>
                  {feature.details}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* User Roles Section */}
      <section style={{
        background: '#f8f9fa',
        padding: '2rem 1rem'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            color: '#1976d2',
            marginBottom: '2rem'
          }}>
            Built for Every User Type
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1.5rem'
          }}>
            {userRoles.map((role, index) => (
              <div
                key={index}
                style={{
                  background: 'white',
                  padding: '2rem',
                  borderRadius: '15px',
                  boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.15)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                }}
              >
                <h3 style={{
                  fontSize: '1.5rem',
                  color: '#1976d2',
                  marginBottom: '1rem',
                  fontWeight: 'bold'
                }}>
                  {role.title}
                </h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#ffffff',
                  marginBottom: '1.5rem',
                  lineHeight: '1.6'
                }}>
                  {role.description}
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0
                }}>
                  {role.features.map((feature, featureIndex) => (
                    <li
                      key={featureIndex}
                      style={{
                        padding: '0.5rem 0',
                        color: '#1976d2',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}
                    >
                      <span style={{ color: '#1976d2', fontWeight: 'bold' }}>✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(#1976d2)',
        padding: '2rem 1rem',
        textAlign: 'center',
        color: 'white'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            marginBottom: '1.5rem',
            fontWeight: 'bold'
          }}>
            Ready to Transform Your Revenue Management?
          </h2>
          <p style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
            marginBottom: '2rem',
            opacity: 0.9,
            lineHeight: '1.6',
            maxWidth: '600px',
            margin: '0 auto 2rem auto'
          }}>
            Join hundreds of MMDAs already using our platform to streamline operations, 
            enhance transparency, and maximize revenue collection efficiency.
          </p>
          <button
            onClick={handleGetStarted}
            style={{
           
              color: 'white',
              border: 'none',
              padding: '18px 36px',
              borderRadius: '30px',
              cursor: 'pointer',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              transition: 'all 0.3s ease',
              boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-3px)';
              e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.5)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
            }}
          >
            Access Dashboard <FaArrowRight />
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        background: '#1976d2',
        color: 'white',
        padding: '2rem 1rem',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            marginBottom: '1rem',
            flexWrap: 'wrap'
          }}>
            <img src={igfwhite} alt="IGF 360" style={{ height: '40px' }} />
            <div>
              <h3 style={{ margin: 0, fontSize: '1.2rem' }}>iGF360 - Revenue Management System</h3>
              <p style={{ margin: 0, opacity: 0.7, fontSize: '0.9rem' }}>Empowering Ghana's MMDAs</p>
            </div>
          </div>
          <p style={{ margin: 0, opacity: 0.7, fontSize: '0.9rem' }}>
            © 2025 iGF360. Built for efficient revenue management and transparency.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
